import { AU, BE, BR, CH, DE, DK, ES, ES_CT, FI, FR, GB, GR, IE, IL, IT, LT, LV, NL, NO, PL, PT, SE, SI, SK, TR, US } from "country-flag-icons/string/3x2";

// Keyed by every LCID so adding a culture fails compilation until it gets a flag
const flagSvgByLcid: Record<Exclude<server.dto.LCID, "unknown">, string> = {
  catalan: ES_CT,
  danish: DK,
  dutch_NL: NL,
  dutch_BE: BE,
  english_AU: AU,
  english_GB: GB,
  english_US: US,
  english_IE: IE,
  finnish: FI,
  french: FR,
  german_DE: DE,
  german_CH: CH,
  greek: GR,
  hebrew: IL,
  italian: IT,
  latvian: LV,
  lithuanian: LT,
  norwegian_NB: NO,
  norwegian_NN: NO,
  polish: PL,
  portuguese_BR: BR,
  portuguese_PT: PT,
  slovak: SK,
  slovenian: SI,
  spanish: ES,
  swedish: SE,
  turkish: TR,
};

export const getCultureFlagSvg = (lcid: server.dto.LCID): string => {
  if (lcid === "unknown") throw new Error("No flag for unknown culture");
  return flagSvgByLcid[lcid];
};
